import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import StyledBox from 'views/rebranded-module/common/components/Logical/LazyLoadWithDataCountsV2/LazyLoadWithDataCountsV2.styles';

type LazyLoadWithDataCountsV2Props = {
  dataCount: number;
  dataLength: number;
  defaultDataCount: number;
  setDataCount: React.Dispatch<React.SetStateAction<number>>;
};

const LazyLoadWithDataCountsV2: React.FC<LazyLoadWithDataCountsV2Props> = ({
  dataCount,
  dataLength,
  defaultDataCount,
  setDataCount,
}) => {
  const moreRef = useRef<HTMLDivElement | null>(null);

  const scrollCallBack: IntersectionObserverCallback = (entries) => {
    if (entries[0].intersectionRatio > 0 && dataLength > dataCount) {
      // the timeout is for showing the spinner so the user doesn't feel something weird happening
      setTimeout(() => {
        setDataCount((prev) => prev + defaultDataCount);
      }, 700);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(scrollCallBack, {
      rootMargin: '0px',
      threshold: 0.8,
    });

    if (moreRef.current) observer.observe(moreRef.current);

    return () => {
      if (moreRef.current) observer.unobserve(moreRef.current);
    };
  }, [dataCount, dataLength, defaultDataCount]);

  if (dataCount < dataLength) {
    return (
      <StyledBox ref={moreRef}>
        <Box className="LLDots" />
      </StyledBox>
    );
  }

  return null;
};

export { LazyLoadWithDataCountsV2 };
